export function priorityTabs() {
    const prioTabs = document.querySelectorAll('.priorityTabs');

    // itterate each element to apply event listeners 
    prioTabs.forEach((element) => {

        let tabs = element.querySelectorAll('.tab')
        let controls = element.querySelector('#tabControls')
        let noTabs = tabs.length
        // get active content
        let currentTab = element.querySelectorAll('.currentTab')
        // prev and next
        let prev = controls.querySelector('.prev');
        let next = controls.querySelector('.next');

        // disabled next and previous links based on currentTab
        if(parseInt(currentTab[0].dataset.tabKey) === 0) {
            prev.setAttribute('disabled', '')
        } else {
            prev.removeAttribute('disabled', '')
        }

        function navNextTab(controls, noTabs) {
            
            //let tabs = element.querySelectorAll('.tab')
            // get active content
            let currentContent = element.querySelector('.currentPane')
            let currentTab = element.querySelectorAll('.currentTab')
            let currentMarker = element.querySelectorAll('.currentMarker')

            // increment current tab
            let increment = (parseInt(currentTab[0].dataset.tabKey) + 1)

            if(increment <= noTabs) {
                // get next tab set
                let nextTab = element.querySelector('#tab-'+increment)
                let nextContent = element.querySelector('#tab-content-'+increment)
                let nextMarker = element.querySelector('#marker-'+increment)

                // set tab classes and attributes
                nextTab.classList.add('active')
                nextTab.classList.add('currentTab')
                nextTab.setAttribute('aria-selected', 'true')
                nextContent.classList.add('active')
                nextContent.classList.add('show')
                nextContent.classList.add('currentPane')
                nextMarker.classList.add('active')
                nextMarker.classList.add('currentMarker')

                // remove from current
                currentTab[0].classList.remove('active')
                currentTab[0].classList.remove('currentTab')
                currentTab[0].setAttribute('aria-selected', 'false')
                currentContent.classList.remove('active')
                currentContent.classList.remove('show')
                currentContent.classList.remove('currentPane')
                currentMarker[0].classList.remove('active')
                currentMarker[0].classList.remove('currentMarker')
                 
            }
            
            // update current tab
            currentContent = element.querySelector('.currentPane')
            currentTab = element.querySelectorAll('.currentTab')
            currentMarker = element.querySelectorAll('.currentMarker')

            // prev and next
            let prev = controls.querySelector('.prev');
            let next = controls.querySelector('.next');

            // disabled next and previous links based on currentTab
            if(parseInt(currentTab[0].dataset.tabKey) === 0) {
                prev.setAttribute('disabled', '')
            } else {
                prev.removeAttribute('disabled', '')
            }

            if(parseInt(currentTab[0].dataset.tabKey) === (noTabs - 1)) {
                next.setAttribute('disabled', '')
            } else {
                next.removeAttribute('disabled', '')
            }
            
        }


        function navPrevTab(controls, noTabs) {
            
            let tabs = element.querySelectorAll('.tab')
            // get active content
            let currentContent = element.querySelector('.currentPane')
            let currentTab = element.querySelectorAll('.currentTab')
            let currentMarker = element.querySelectorAll('.currentMarker')

            // increment current tab
            let increment = (parseInt(currentTab[0].dataset.tabKey) - 1)

            if(increment <= noTabs && increment >= 0) {
                // get next tab set
                let prevTab = element.querySelector('#tab-'+increment)
                let prevContent = element.querySelector('#tab-content-'+increment)
                let prevMarker = element.querySelector('#marker-'+increment)

                // set tab classes and attributes
                prevTab.classList.add('active')
                prevTab.classList.add('currentTab')
                prevTab.setAttribute('aria-selected', 'true')
                prevContent.classList.add('active')
                prevContent.classList.add('show')
                prevContent.classList.add('currentPane')
                prevMarker.classList.add('active')
                prevMarker.classList.add('currentMarker')

                // remove from current
                currentTab[0].classList.remove('active')
                currentTab[0].classList.remove('currentTab')
                currentTab[0].setAttribute('aria-selected', 'false')
                currentContent.classList.remove('active')
                currentContent.classList.remove('show')
                currentContent.classList.remove('currentPane')
                currentMarker[0].classList.remove('active')
                currentMarker[0].classList.remove('currentMarker')

            }

            // update current tab
            currentContent = element.querySelector('.currentPane')
            currentTab = element.querySelectorAll('.currentTab')
            currentMarker = element.querySelectorAll('.currentMarker')

            // prev and next
            let prev = controls.querySelector('.prev');
            let next = controls.querySelector('.next');

            // disabled next and previous links based on currentTab
            if(parseInt(currentTab[0].dataset.tabKey) === 0) {
                prev.setAttribute('disabled', '')
            } else {
                prev.removeAttribute('disabled', '')
            }

            if(parseInt(currentTab[0].dataset.tabKey) >= noTabs) {
                next.setAttribute('disabled', '')
            } else {
                next.removeAttribute('disabled', '')
            }

        }

        function updateTabAfterClick(selected, controls, noTabs) {
            let key = selected.dataset.tabKey

            // current tab data
            let currentContent = element.querySelector('.currentPane')
            let currentTab = element.querySelectorAll('.currentTab')
            let currentMarker = element.querySelectorAll('.currentMarker')

            // remove from current
            currentTab[0].classList.remove('active')
            currentTab[0].classList.remove('currentTab')
            currentTab[0].setAttribute('aria-selected', 'false')
            currentContent.classList.remove('active')
            currentContent.classList.remove('show')
            currentContent.classList.remove('currentPane')
            currentMarker[0].classList.remove('active')
            currentMarker[0].classList.remove('currentMarker')

            // current tab data
            let selectedContent = element.querySelector('#tab-content-'+key)
            let selectedTab = element.querySelector('#tab-'+key)
            let selectedMarker = element.querySelector('#marker-'+key)


            // set tab classes and attributes
            selectedTab.classList.add('active')
            selectedTab.classList.add('currentTab')
            selectedTab.setAttribute('aria-selected', 'true')
            selectedContent.classList.add('active')
            selectedContent.classList.add('show')
            selectedContent.classList.add('currentPane')
            selectedMarker.classList.add('active')
            selectedMarker.classList.add('currentMarker')

            // current tab data
            currentContent = element.querySelector('.currentPane')
            currentTab = element.querySelectorAll('.currentTab')
            currentMarker = element.querySelectorAll('.currentMarker')

            // update navigation
            let prev = controls.querySelector('.prev');
            let next = controls.querySelector('.next');

            // disabled next and previous links based on currentTab
            if(parseInt(currentTab[0].dataset.tabKey) === 0) {
                prev.setAttribute('disabled', '')
            } else {
                prev.removeAttribute('disabled', '')
            }

            if(parseInt(currentTab[0].dataset.tabKey) >= (noTabs - 1)) {
                next.setAttribute('disabled', '')
            } else {
                next.removeAttribute('disabled', '')
            }
            
        }

        function handleTabClick(tab) {
            updateTabAfterClick(tab, controls, noTabs)
        }

        function handleNextTabClick(e) {
            navNextTab(controls, noTabs)
        }

        function handlePrevTabClick(e) {
            navPrevTab(controls, noTabs)
        }

        //console.log(tabs)
        
        tabs.forEach((tab) => {
            tab.addEventListener('click', function(e){
                handleTabClick(tab)
            })
        })

        next.addEventListener('click', handleNextTabClick);
        prev.addEventListener('click', handlePrevTabClick);

    
    })
}